/* eslint-disable import/prefer-default-export */
// export const tabs = state => state.tabs;
export const tabs = state => {
    return state.tabs;
};
